import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "modal-body-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_oio_button, {
      class: "oio-action-item",
      size: "small",
      onClick: _cache[0] || (_cache[0] = () => _ctx.visible = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 生成考勤报表 ")
      ]),
      _: 1
    }),
    _createVNode(_component_oio_modal, {
      width: "40%",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "请选择账期"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_oio_button, {
          onClick: _ctx.cancel,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_oio_button, {
          onClick: _ctx.submit,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_oio_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_oio_form_item, {
                label: "账期选择",
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    value: _ctx.selectValue,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectValue) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateList, (date) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: date,
                          key: date
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(date), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}